import React from "react";
import { Link } from "react-router-dom";

import { Col, Container, Row } from "react-bootstrap";
import { Call } from "iconsax-react";

import FooterLogo from "../../../image/footer-logo.png";
import BuletsRectangle from "../../../image/footer/bullets.png";
import { footerLists, certificateList } from "../../../utility/content/FooterDatas";
import { socialData } from "../../../utility/content/SocialMedia";

import scrollToTop from "../../../libs/scrollToTop";

import {
  CertificateImg,
  FooterButtom,
  FooterTop,
  SocialLi,
  StyledBuletsRectangleImg,
  StyledContactLi,
  StyledCopyright,
  StyledFooter,
  StyledH5,
} from "./styledFooter";

export default function FooterComponent() {
  return (
    <StyledFooter className="text-center text-lg-end">
      <Container>
        <FooterTop className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={1}>
              <StyledBuletsRectangleImg
                src={BuletsRectangle}
                alt="BuletsRectangle"
                right
              />
            </Col>
            <Col xs={12} md={5}>
              <Row>
                {Object.values(footerLists).map((item, index) => {
                  return (
                    <Col key={item.id ? item.id : index} xs={12} lg={6} className="mb-3">
                      <StyledH5 className="mx-auto mx-lg-0 mb-4 mb-md-5">
                        {Object.getOwnPropertyNames(footerLists)[index]}
                      </StyledH5>
                      <ul className="list-unstyled">
                        {Object.values(footerLists)[index].map((item) => {
                          if (item.href) {
                            return (
                              <StyledContactLi key={item.id} className="mb-3">
                                <a href={item.href}>{item.text}</a>
                              </StyledContactLi>
                            );
                          }
                          if (item.path) {
                            return (
                              <StyledContactLi key={item.id} className="mb-3">
                                <Link to={item.path} onClick={scrollToTop}>
                                  {item.text}
                                </Link>
                              </StyledContactLi>
                            );
                          }
                          return (
                            <StyledContactLi key={item.id} className="mb-3">
                              <p className="mb-0">{item.text}</p>
                            </StyledContactLi>
                          );
                        })}
                      </ul>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col xs={12} md={5} lg={4}>
              <div className="text-center">
                <Link to="./">
                  <img
                    src={FooterLogo}
                    alt="footer-logo"
                    title="لوگو آزتو"
                    width="125"
                    height="115"
                    className="img-fluid mb-4"
                  />
                </Link>
                <p>روزهای کاری هفته از 8 تا 17 پاسخگو هستیم.</p>
                <p>
                  <Call size={18} color="var(--secondary-color)" className="icon" />{" "}
                  <a href="tel:02177245204" title="تماس با آزتو">
                    شماره تماس پشتیبانی و فروش: 77245204-021
                  </a>
                </p>
              </div>
              <StyledBuletsRectangleImg
                src={BuletsRectangle}
                alt="BuletsRectangle"
                left
              />
            </Col>
          </Row>
        </FooterTop>
        <FooterButtom>
          <Row className="align-items-end">
            <Col xs={12} md={4} className="order-last order-md-first">
              <StyledCopyright className="text-center text-sm-end">
                © تمام حقوق این سایت متعلق به شرکت فرآموز هنداسه می‌باشد.
              </StyledCopyright>
            </Col>
            <Col xs={12} md={4} className="mb-md-5">
              <ul className="list-unstyled d-flex justify-content-between">
                {certificateList.map((certificate) => {
                  try{
                    return (
                      <li key={certificate.id} className="w-100">
                        <a href={certificate.href} target={certificate.target}>
                          <CertificateImg
                            id={certificate.id}
                            src={certificate.imgSrc}
                            alt={certificate.src}
                            referrerPolicy={certificate.referrerPolicy}
                          />
                        </a>
                      </li>
                    );

                  }catch(e){}
                })}
              </ul>
            </Col>
            <Col xs={12} md={4}>
              <ul className="list-unstyled d-flex justify-content-center">
                {socialData.map((item) => {
                  return (
                    <SocialLi key={item.id} className="mx-2">
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                        className="social-link"
                      >
                        {item.icon}
                      </a>
                    </SocialLi>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </FooterButtom>
      </Container>
    </StyledFooter>
  );
}
